var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33326 12.3335C5.33326 10.8607 4.13949 9.66674 2.66674 9.66674C1.194 9.66674 0 10.8607 0 12.3335C0 13.8062 1.194 15 2.66674 15C4.13949 15 5.33326 13.8062 5.33326 12.3335Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 12.3335C14.667 10.8607 13.473 9.66674 12.0002 9.66674C10.5275 9.66674 9.3335 10.8607 9.3335 12.3335C9.3335 13.8062 10.5275 15 12.0002 15C13.473 15 14.667 13.8062 14.667 12.3335Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 9.66674C22.8058 9.66674 23.9998 10.8607 23.9998 12.3335C23.9998 13.8062 22.8058 15 21.333 15C19.8603 15 18.6665 13.8062 18.6665 12.3335C18.6665 10.8607 19.8603 9.66674 21.333 9.66674Z",
    fill: "#A0AEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33326 2.99732C5.33326 1.52458 4.13949 0.330804 2.66674 0.330804C1.194 0.330804 0 1.52458 0 2.99732C0 4.47006 1.194 5.66406 2.66674 5.66406C4.13949 5.66406 5.33326 4.47006 5.33326 2.99732Z",
    fill: "#A0AEC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.330804C13.473 0.330804 14.667 1.52458 14.667 2.99732C14.667 4.47006 13.473 5.66406 12.0002 5.66406C10.5275 5.66406 9.3335 4.47006 9.3335 2.99732C9.3335 1.52458 10.5275 0.330804 12.0002 0.330804Z",
    fill: "#A0AEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 2.99732C23.9998 1.52458 22.8058 0.330804 21.333 0.330804C19.8603 0.330804 18.6665 1.52458 18.6665 2.99732C18.6665 4.47006 19.8603 5.66406 21.333 5.66406C22.8058 5.66406 23.9998 4.47006 23.9998 2.99732Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.8a940587739f57875184e29a4904aa26.svg";
export { ForwardRef as ReactComponent };